function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_3339",
  "data-name": "Group 3339",
  transform: "translate(-317 -168)"
}, React.createElement("circle", {
  id: "Ellipse_1916",
  "data-name": "Ellipse 1916",
  cx: 13,
  cy: 13,
  r: 13,
  transform: "translate(317 168)",
  fill: "#3db6fb"
}), React.createElement("g", {
  id: "Group_3310",
  "data-name": "Group 3310",
  transform: "translate(322.352 173.353)"
}, React.createElement("path", {
  id: "Path_1527",
  "data-name": "Path 1527",
  d: "M423.2,566.547A7.775,7.775,0,0,0,411.709,577l.064.076-.044.089a3.209,3.209,0,0,1-1.34,1.477.591.591,0,0,0,.171,1.113,3.924,3.924,0,0,0,.6.045,4.592,4.592,0,0,0,2.7-.9l.078-.056.084.045a7.774,7.774,0,0,0,9.171-12.351Zm-.424,10.572a7.175,7.175,0,0,1-8.709,1.117.3.3,0,0,0-.364.047l-.017.018-.034.022a4.024,4.024,0,0,1-2.484.884h-.47l.376-.277a4.314,4.314,0,0,0,1.311-1.745.311.311,0,0,0,.015-.193l0-.02a.321.321,0,0,0-.074-.172,7.176,7.176,0,1,1,10.454.32Z",
  transform: "translate(-409.925 -564.268)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.7
}), React.createElement("path", {
  id: "Path_1528",
  "data-name": "Path 1528",
  d: "M458.483,612.453a.4.4,0,1,0,.4.4A.4.4,0,0,0,458.483,612.453Z",
  transform: "translate(-450.71 -605.08)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.7
}), React.createElement("path", {
  id: "Path_1529",
  "data-name": "Path 1529",
  d: "M477.24,612.453a.4.4,0,1,0,.4.4A.4.4,0,0,0,477.24,612.453Z",
  transform: "translate(-466.597 -605.08)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.7
}), React.createElement("path", {
  id: "Path_1530",
  "data-name": "Path 1530",
  d: "M439.726,612.453a.4.4,0,1,0,.4.4A.4.4,0,0,0,439.726,612.453Z",
  transform: "translate(-434.824 -605.08)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.7
})));

var SvgChatMarker = function SvgChatMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChatMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chatMarker.725cc50f.svg";
export { ForwardRef as ReactComponent };